import { z } from "zod";
import { CbhFeatureFlag } from "./CbhFeatureFlag";

export const cbhFeatureFlags = {
  [CbhFeatureFlag.HOME_HEALTH_ENABLED]: z.boolean(),
  [CbhFeatureFlag.INVOICE_HISTORY_REVAMP]: z.boolean(),
  [CbhFeatureFlag.HOME_HEALTH_PAY_RATES]: z.object({
    ADMISSION: z.object({
      RN: z.number(),
    }),
    RESUMPTION_OF_CARE: z.object({
      RN: z.number(),
    }),
    DISCHARGE: z.object({
      RN: z.number(),
    }),
    RECERTIFICATION: z.object({
      RN: z.number(),
    }),
    REGULAR: z.object({
      CHHA: z.number(),
      CNA: z.number(),
      Caregiver: z.number(),
      LVN: z.number(),
      RN: z.number(),
    }),
    SUPERVISORY: z.object({
      RN: z.number(),
    }),
  }),
  [CbhFeatureFlag.INVOICE_DISPUTE_PAGE]: z.boolean(),
  [CbhFeatureFlag.STREAKS_PRE_REWARD]: z.boolean(),
  [CbhFeatureFlag.HOME_HEALTH_WORKER_CHAT_ENABLED]: z.boolean(),
  [CbhFeatureFlag.HOME_HEALTH_FOOTER_URLS]: z.object({
    demoUrl: z.string(),
    faqUrl: z.string(),
  }),
  [CbhFeatureFlag.HOME_HEALTH_BONUS_PAYMENT]: z.boolean(),
  [CbhFeatureFlag.HCP_SOFT_DELETION]: z.boolean(),
  [CbhFeatureFlag.SHOW_SHIFT_BLOCK_LABEL_ALTERNATE_COPY]: z.boolean(),
  [CbhFeatureFlag.MAGIC_POINTS]: z.object({
    eligibleForFillGuarantee: z.boolean(),
    enabled: z.boolean(),
    pointsBudget: z.number(),
    pointsShop: z.object({
      magicShiftCost: z.number(),
    }),
  }),
  [CbhFeatureFlag.SHOW_AVAILABLE_WORKERS_CONFIG]: z.object({ qualifications: z.array(z.string()) }),
};

export type CbhFeatureFlags = {
  [K in keyof typeof cbhFeatureFlags]: z.infer<typeof cbhFeatureFlags[K]>;
};
